<template>
  <div>
    <StatusIcon
      :class="$style.statusIcon"
      :item="item"
      :type="statusIconTypes.adBridgeAgent"
    />
    <p :class="$style.details">
      <span :class="$style.agentType">
        {{ item.type === importAgent ? 'Import' : 'Sync' }}
      </span>
      <span v-if="item.version">
        {{ item.version }} {{ isUpdateAvailable(item) ? '(update available)' : '' }}
      </span>
    </p>
  </div>
</template>
<script>
import {
  AdBridgeAgentTypes,
  BodyComponentConsts,
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import StatusIcon from 'client/components/ItemTable/BodyComponents/StatusIcon.vue';

const { statusIconTypes } = BodyComponentConsts;
const storeModule = StoreModuleMap[ItemTypeConsts.adBridgeAgent];

export default {
  name: 'AdBridgeVersion',

  components: {
    StatusIcon,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ...AdBridgeAgentTypes,
      statusIconTypes,
    };
  },

  computed: {
    ...mapGetters(storeModule, [
      'isUpdateAvailable',
    ]),
  },
};
</script>
<style module>
.statusIcon {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}

.details {
  display: inline-block;
}

.agentType {
  display: block;
  margin-bottom: 5px;
}
</style>
